/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResponseLong
 */
export interface ResponseLong {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseLong
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseLong
     */
    message?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponseLong
     */
    data?: number;
}

/**
 * Check if a given object implements the ResponseLong interface.
 */
export function instanceOfResponseLong(value: object): value is ResponseLong {
    return true;
}

export function ResponseLongFromJSON(json: any): ResponseLong {
    return ResponseLongFromJSONTyped(json, false);
}

export function ResponseLongFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseLong {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : json['data'],
    };
}

export function ResponseLongToJSON(json: any): ResponseLong {
    return ResponseLongToJSONTyped(json, false);
}

export function ResponseLongToJSONTyped(value?: ResponseLong | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'],
    };
}

